<template>
    <div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

      <h1>Acessibilidade</h1>

      <div class="form-container mb-3" style="font-size: small;">
        <div class="form-title" style="background-color: gray; color: white; font-weight: bold;"><!-- Subtitulo --></div>

        <h5>Introdução</h5>

        <p>O eproc é um sistema web planejado para ser acessível e de fácil utilização a todos os usuários.Na parte superior do sistema existe uma barra de acessibilidade, onde se encontram:</p>
        <ul>
            <li>Atalhos de navegação para as principais seções das páginas (conteúdo, menu e pesquisa processual), facilitando a utilização de leitores de tela;</li>
            <li>Diminuir ou aumentar o tamanho dos textos;</li>
            <li>Habilitar alto contraste;</li>
            <li>Habilitar o tradutor de libras - A suite VLibras é um conjunto de ferramentas gratuitas e de código aberto que traduz conteúdos digitais (texto, áudio e video) em Português para Libras, tornando computadores, celulares e plataformas Web mais acessíveis para as pessoas surdas.</li>
        </ul>
        <p>Para relatar problemas de acessibilidade no eproc, contate-nos através do e-mail* <a href="mailto:contato@twmsimuladores.com.br">contato@twmsimuladores.com.br</a>**, e nos ajude a melhorar a experiência de todos.
        <br /><i><strong>*Atenção:</strong> Este canal é exclusivo para tecnologias assistivas. Para problemas de acesso ou outras questões, contate o suporte de sua localidade através do menu 'Fale conosco'.</i>
        <br /><strong><i>**Atenção:</i></strong> Esta página também se encontra no simulador oficial do eproc, porém o e-mail indicado para problemas de acessibilidade é do fornecedor deste simulador acadêmico.
        </p>

      </div>

      <div class="form-container mb-3" style="font-size: small;">
        <div class="form-title" style="background-color: gray; color: white; font-weight: bold;"><!-- Subtitulo --></div>

        <h5>Teclas de Atalho</h5>
        <p>A seguir, as principais teclas de atalho disponíveis no sistema:</p>
        <h6>Geral</h6>
            <table class="table table-striped table-bordered mt-2 border" style="width: 50%;">
                <thead>
                    <tr class="text-center">
                        <th scope="col" style="background-color: lightgrey;">Atalho</th>
                        <th scope="col" style="background-color: lightgrey;">Ação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>TAB</td>
                        <td>Navegação entre os componentes da tela</td>
                    </tr>
                    <tr>
                        <td>SHIFT + TAB</td>
                        <td>Navegação inversa entre os componentes da tela</td>
                    </tr>
                    <tr>
                        <td>ALT + 1</td>
                        <td>Reexibe a barra de acessibilidade (se oculta) e posiciona o cursos no primeiro link da página (Ir para conteúdo)</td>
                    </tr>
                    <tr>
                        <td>ALT + F1</td>
                        <td>Página de informações sobre acessibilidade</td>
                    </tr>
                    <tr>
                        <td>CTRL + ALT + F</td>
                        <td>Acesso à pesquisa rápida pelo número do processo</td>
                    </tr>
                    <tr>
                        <td>CTRL + SHIFT + H</td>
                        <td>Acesso à página inicial</td>
                    </tr>
                    <tr>
                        <td>CTRL + SHIFT + U</td>
                        <td>Perfil do usuário</td>
                    </tr>
                    <tr>
                        <td>CTRL + SHIFT + F4</td>
                        <td>Encerrar sessão</td>
                    </tr>
                </tbody>
            </table>

            <h6>Capa do Processo</h6>
            <table class="table table-striped table-bordered mt-2 border" style="width: 50%;">
                <thead>
                    <tr class="text-center">
                        <th scope="col" style="background-color: lightgrey;">Atalho</th>
                        <th scope="col" style="background-color: lightgrey;">Ação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>ALT + SHIFT + D</td>
                        <td>Download Completo</td>
                    </tr>
                    <tr>
                        <td>Alt + O</td>
                        <td>Movimentar processo</td>
                    </tr>
                </tbody>
            </table>
      </div>
      

    </div>
</template>
  
<script>
  
export default {
    data() {
        return {
          BASE_URL: window.Laravel.baseUrl,

        };
    },
    methods: {
        
    },
        
};
</script>
  
<style scoped>
h1{
    font-size: 26px;
}

.form-container {
    border: 1px solid gray; /* Borda fina cinza */
    padding: 10px;
    position: relative; /* Posição relativa para o posicionamento do título */
    margin-top: 5px; /* Espaçamento superior para visualização do título */
    margin-left: 5px;
    margin-right: 5px;
    border-radius: 5px;
    background-color: #FFFFFF;
}

.form-title {
    position: absolute; /* Posicionamento absoluto do título */
    top: -15px; /* Posiciona o título acima da borda */
    left: 10px; /* Espaçamento da esquerda para o título */
    background: white; /* Fundo branco para o título */
    padding: 0 1px; /* Espaçamento interno do título */
    font-weight: bold;;
}

</style>
  